module.exports = "https://images.shiksha.ws/saassets/media/gnb_sprite.e9f48911.svg";